//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { ListViewSmallSVG } from './svg'

interface ListViewSmallIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const ListViewSmallIcon: React.FC<ListViewSmallIconProps> = forwardRef<
  ListViewSmallIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon ref={ref} boxSize={boxSize} as={ListViewSmallSVG} sx={sx} />
))
